export default __webpack_public_path__ + "static/media/18.4b0456c3.jpg";